import { ConstellationOneListing } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import ImageGallery from '../../components/ImageGallery/ImageGallery.js';
import { useMlsDataSheetParams } from './MLSDataSheet/hooks/useMlsDataSheetParams.js';
import { NoData } from './NoData.js';
import { MLSDataHeader } from './Tkv2MlsDataHeader/MLSDataHeader.js';
import { ReferenceViewID } from './index.js';

export const Tkv2MlsImages = ({
  listingData,
  isPopout,
  referenceViewID,
}: {
  listingData: ConstellationOneListing;
  isPopout: boolean;
  referenceViewID: ReferenceViewID;
}) => {
  const mlsDataSheetParams = useMlsDataSheetParams();
  return (listingData.Media || []).length === 0 ? (
    <NoData text="No property images available" referenceViewID={referenceViewID} updateMLSInfo />
  ) : (
    <Flex
      width="100%"
      maxWidth="70rem"
      marginLeft="auto"
      marginRight="auto"
      flexDirection="column"
      paddingLeft="1rem"
      paddingRight="1rem"
      minWidth="30rem"
    >
      <Flex marginBottom="1rem">
        <MLSDataHeader
          listingData={listingData}
          isPopout={isPopout}
          referenceViewID={referenceViewID}
          headerType="images"
          mlsDataSheetParams={mlsDataSheetParams}
        />
      </Flex>
      <ImageGallery imageURLs={listingData.Media?.map((medium) => medium.MediaURL) ?? []} />
    </Flex>
  );
};
